// extracted by mini-css-extract-plugin
export var fadeInAnimation = "AsideFooter-module--fadeInAnimation--a57f2";
export var title = "AsideFooter-module--title--3a7e9";
export var wrapper = "AsideFooter-module--wrapper--e1c7c";